import React from 'react';
import ArrowImg from '../img/arrow.svg'

function CriteriaRating() {
  return (
    <div>
            <div className="ratings-content">
    <div className="content-overlay">
    <div className='logo-cont'>
        <div className="logo-image"></div>
        </div>
      <h1 className="main-title">Критерии оценки для получения</h1>
      <h1 className="main-title">Международной Премии "Олимп красоты"</h1>
    </div>
    </div>
    <section className='main-section'>
          <div className='ratings-wrapper'>
    <section className='about-section'>
    <div className='ratings-wrapper'>
          <div className='title'>Парикмахеры и стилисты</div>
          <ul className="content-details-list">
          <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Оригинальность и креативность причесок;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Сложность и техничность выполнения стрижек и укладок;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Знание и применение последних трендов в парикмахерском искусстве;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Качество и долговечность стиля;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Объем и качество образовательного вклада в индустрию (мастер-классы, обучение).</li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
    <div className='ratings-wrapper'>
          <div className='title'>Make-up артисты</div>
          <ul className="content-details-list">
          <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Оригинальность и креативность макияжа;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Сложность и техничность выполнения;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Знание и применение последних трендов в визажном искусстве;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Качество и стойкость макияжа;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Образовательный вклад в индустрию (мастер-классы, обучение).</li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
      <div className='ratings-wrapper'>
          <div className='title'>Мастера маникюра и педикюра</div>
          <ul className="content-details-list">
          <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Техническое мастерство в исполнении маникюра и педикюра;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Уникальность дизайна и росписи ногтей;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Соблюдение высоких стандартов гигиены и безопасности;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Успешное использование новаторских продуктов и технологий;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Клиентские отзывы и репутация среди клиентов.</li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
      <div className='ratings-wrapper'>
          <div className='title'>Косметологи и эстетисты</div>
          <ul className="content-details-list">
          <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Доказательства успешного применения передовых техник и процедур;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Видимые и долгосрочные результаты у клиентов;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Научные публикации или разработки в области эстетической косметологии;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Развитие и внедрение новых косметических продуктов;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Участие в профессиональных конференциях и форумах.</li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
      <div className='ratings-wrapper'>
          <div className='title'>Мастера перманентного макияжа</div>
          <ul className="content-details-list">
          <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Способность к точному и тонкому нанесению перманентного макияжа;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Инновационные методы перманентного макияжа;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Соблюдение высочайших стандартов безопасности и гигиены;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Предоставление широкого спектра процедур перманентного макияжа;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Постоянное образование и сертификация в этой сфере.</li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
      <div className='ratings-wrapper'>
          <div className='title'>Тату мастера</div>
          <ul className="content-details-list">
          <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Уникальность стиля и оригинальность исполнения;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Владение разнообразными техниками и стилями татуировки;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Портфолио высококачественных и долговременных татуировок;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Приверженность безопасности и послепроцедурному уходу;</li>
            <li>  <span class="arrow-icon-wrapper">
          <img src={ArrowImg} className="my-icon-style" alt="ArrowImg" />
            </span>Развитие и обучение в области тату-арт.</li>
        </ul>
        </div>
      </section>
    </div>
    </section>
    </div>
  );
}

export default CriteriaRating;
